import moment from "moment-timezone";
import { Text } from "@radix-ui/themes";

export function ContentItemDate(props: { contentItem: ContentItem }) {
  const date = moment(props.contentItem.created_at).format("MMM D, YYYY");

  return (
    <Text color={"gray"} suppressHydrationWarning>
      {date}
    </Text>
  );
}
